<template>
	<div id="loginpage" class="loginregist" :style="curWebsite.type == 2 ? 'background:#fff' : ''">
		<div style="width:100%;" :class="{ 'por': true }">
			<div class="login-top-bar">
				<div class="oh" v-if="!demonstrate && curWebsite.selfControl">
					<a href="#aboutUs" class="fr">关于我们</a>
					<a href="http://c.ocn.com.cn/" target="_blank" class="fr">中投顾问</a>
					<a href="http://www.ocn.com.cn/rpt002.htm" target="_blank" class="fr">中投产业研究院</a>
					<a href="http://www.ocn.com.cn/" target="_blank" class="fr">中投网</a>
				</div>
			</div>
			<!-- szy-login -->
			<div class="zl-index widthPC-90 margin-x-auto" v-if="curWebsite.type == 2">
				<h2 class="text-center mt-5 mb-3">中投顾问产业大脑，<span
						style="font-weight: normal;">产业研究、产业投资与产业招商数智化高效工具。</span></h2>
				<div class="flexcss">
					<div v-for="(zl_cydl, index) in zl_cydl_list" class="zl-index-con" :key="index" style="width: 530px"
						@mouseenter="isShowZldnM = index + 1" @mouseleave="isShowZldnM = 0">
						<p class="text-center name mb-1">{{ zl_cydl.name }}</p>
						<div class="zl-index-cydn">
							<div class="left-font border" style="width: 530px;">
								<h3 class="title" id="weisite-title" style="font-size: 24px;">{{ zl_cydl.title }}</h3>
								<ul id="font-list" style="font-size: 16px;">
									<li :key="index" v-for="(item, index) in zl_cydl.fontlist">{{ item }}</li>
								</ul>
								<p class="yellowfont">……所有工作，只需点击几下鼠标就完成</p>
							</div>
						</div>
						<div class="clear-after isShowZldnM-box">
							<span class="cur-pointer fl inline-block mt1"
								@click="hanlderService('introduction' + (index + 1))">功能介绍 > </span>
							<span class="cur-pointer fr inline-block mt1"
								@click="hanlderService('service' + (index + 1))">服务方式 > </span>
						</div>
					</div>
				</div>
				<div class="bannerconbox my-2">
					<div class="con">
						<p class="ad-cd25">为了让用户能零门槛把握最新产业投资机会 ，<b>中投顾问产业大脑</b>特开展热点报告“<span
								class="red-font">限时免费阅读活动</span>”，现在即可申请<span class="red-font">免费</span>阅读以下报告：</p>
						<div class="rpt-box">
							<ul>
								<li><a href="https://www.ocn.com.cn/reports/18442renxingjiqiren.shtml" target="blank"
										title="2025-2029年中国未来产业之人形机器人行业趋势预测及投资机会研究报告"
										class="rpt-title">2025-2029年中国未来产业之人形机器人行业趋势预测及投资机会研究报告</a><a class="curp apply"
										@click="openSmWindow('https://q.url.cn/abLCUe?_type=wpa&amp;qidian=true')">现在申请
										&gt; </a></li>
								<li><a href="https://www.ocn.com.cn/reports/18582rengongzhinengdamoxing.shtml"
										target="blank" title="2025-2029年中国未来产业之人工智能大模型行业应用场景剖析及投资机会研究报告"
										class="rpt-title">2025-2029年中国未来产业之人工智能大模型行业应用场景剖析及投资机会研究报告</a><a
										class="curp apply"
										@click="openSmWindow('https://q.url.cn/abLCUe?_type=wpa&amp;qidian=true')">现在申请
										&gt; </a></li>
								<li><a href="https://www.ocn.com.cn/reports/18557dikongjingjijichusheshi.shtml"
										target="blank" title="2025-2029年中国低空经济基础设施投资模式评估及规划建议报告"
										class="rpt-title">2025-2029年中国低空经济基础设施投资模式评估及规划建议报告</a><a class="curp apply"
										@click="openSmWindow('https://q.url.cn/abLCUe?_type=wpa&amp;qidian=true')">现在申请
										&gt; </a></li>
								<li><a href="https://www.ocn.com.cn/2012/1204yanglao.shtml" target="blank"
										title="2025-2029年中国养老产业投资分析及前景预测报告"
										class="rpt-title">2025-2029年中国养老产业投资分析及前景预测报告</a><a class="curp apply"
										@click="openSmWindow('https://q.url.cn/abLCUe?_type=wpa&amp;qidian=true')">现在申请
										&gt; </a></li>
								<li><a href="https://www.ocn.com.cn/reports/18587xinxingdianchiyingyongchangjing.shtml"
										target="blank" title="2025-2029年中国新型电池行业应用场景剖析及投资机会研究报告"
										class="rpt-title">2025-2029年中国新型电池行业应用场景剖析及投资机会研究报告</a><a class="curp apply"
										@click="openSmWindow('https://q.url.cn/abLCUe?_type=wpa&amp;qidian=true')">现在申请
										&gt; </a></li>
								<li><a href="https://www.ocn.com.cn/reports/18586changqizibennaixinziben.shtml"
										target="blank" title="22025年中国长期资本耐心资本发展白皮书"
										class="rpt-title">2025年中国长期资本耐心资本发展白皮书</a><a class="curp apply"
										@click="openSmWindow('https://q.url.cn/abLCUe?_type=wpa&amp;qidian=true')">现在申请
										&gt; </a></li>
								<li><a href="https://www.ocn.com.cn/reports/18585xinnengyuanzhinengwanglianqiche.shtml"
										target="blank" title="2025-2029年中国未来产业之新能源及智能网联汽车产业趋势预测及投资机会研究报告"
										class="rpt-title">2025-2029年中国未来产业之新能源及智能网联汽车产业趋势预测及投资机会研究报告</a><a
										class="curp apply"
										@click="openSmWindow('https://q.url.cn/abLCUe?_type=wpa&amp;qidian=true')">现在申请
										&gt; </a></li>
								<li><a href="https://www.ocn.com.cn/reports/18538duanju.shtml" target="blank"
										title="2025-2029年中国短剧行业深度调研及投资前景预测报告"
										class="rpt-title">2025-2029年中国短剧行业深度调研及投资前景预测报告</a><a class="curp apply"
										@click="openSmWindow('https://q.url.cn/abLCUe?_type=wpa&amp;qidian=true')">现在申请
										&gt; </a></li>
								<li><a href="https://www.ocn.com.cn/reports/18595biaoganchengshikejichuangxin.shtml"
										target="blank" title="中国标杆城市科技创新与产业发展成功经验深度分析报告"
										class="rpt-title">中国标杆城市科技创新与产业发展成功经验深度分析报告(2025版)</a><a class="curp apply"
										@click="openSmWindow('https://q.url.cn/abLCUe?_type=wpa&amp;qidian=true')">现在申请
										&gt; </a></li>
							</ul>
						</div>
					</div>
				</div>
			</div>
			<div class="login-center syzs-login flexcss" v-if="curWebsite.type == 7">
				<el-carousel :interval="3000" height="100%">
					<el-carousel-item class="swiper-item1">
						<div class="swiper-item ">
							<!-- <div class="swiper-item1-con">
								<h1>WorldCluster Hub</h1>
								<p class="font-22 mb-5">世界产业集群中心</p>
								<p class="font-28 mb-3">链接全球商机 共创繁荣未来</p>
								<p class="font-20"><span>产业资本</span> <span>产业集群</span>  <span>产业数据</span> <span>产业智库</span> <span>财经媒体</span></p>
							</div> -->
						</div>
					</el-carousel-item>
					<el-carousel-item class="swiper-item2">
						<div class="swiper-item">
							<!-- <div class="swiper-item2-con">
								<h1 class="mb-2">GlobaCorp Nexus</h1>
								<p class="font-22">一触即发—全球商机尽在掌握</p>
							</div> -->
						</div>
					</el-carousel-item>
					<el-carousel-item class="swiper-item3">
						<div class="swiper-item ">
							<!-- <div class="swiper-item3-con">
								<h1 class="mb-3">IndustryConnect</h1>
								<p class="font-22 mb-2">全球视野 本地触点 </p>
								<p class="text-right font-22 widthPC-90">—您的商机伙伴 </p>
							</div> -->
						</div>
					</el-carousel-item>
					<el-carousel-item class=" swiper-item4">
						<div class="swiper-item">
							<!-- <div class="swiper-item4-con">
							<h1 class="mb-3">Eeolntegrate Platform</h1>
							<p class="font-28 mb-3">世界舞台 商机无限</p>
							<p class="font-28 widthPC-90 text-right">——与您共赢未来 </p>
							</div> -->
						</div>
					</el-carousel-item>
				</el-carousel>
				<!-- <div class="left">
					<img src="../../assets/images/sh_login_logo.png" class="sh-login-logo" alt="">
					<h3 class="title">上海产业集群大数据平台</h3>
					<p class="englist_font">Shanghai industrial cluster big data platform</p>	
				</div>
				<div class="right">
					<h4 class="title2">系统登录</h4>
					<el-input class="el-input-css" v-model="logindata.username" placeholder="手机号/用户名" name="username"><i
							slot="prefix" class="el-input__icon el-icon-user-solid"></i></el-input>
					<el-input class="el-input-css" type="password" v-model="logindata.password" placeholder="请输入密码" name="password"><i slot="prefix" class="el-input__icon el-icon-lock"></i></el-input>
					<button type="submit" class="submitbtn" @click="passwordLogin()">登录</button>
					<p class="errortext mgax">{{errortext}}</p>
				</div> -->
			</div>
			<div class="login-center syzs-login1" v-if="curWebsite.type == 7">
				<div class="widthPC-80 margin-x-auto syzs-login1-con">
					<h1 class="font-50 py-5 text-center">GLobalLink</h1>
					<h1 class="text-center pb-4 font-52">智慧科技 产业升级 尽在人工智能产业平台</h1>
					<p class="text-center pb-4">VIP账户登录</p>

					<div class="right text-center oh">
						<div class="oh mb-2">
							<span class="cur-pointer fl login_type fff-font" :class="!isPwdLogin ? 'active-fff' : ''"
								@click="isPwdLogin = false; errortext = '';"> 短信验证码登录 >> </span>
							<span class="cur-pointer fr login_type fff-font" :class="isPwdLogin ? 'active-fff' : ''"
								@click="isPwdLogin = true; errortext = '';"> 账号密码登录 >> </span>
						</div>
						<!-- <el-input class="el-input-css mb-2" v-model="logindata.username" placeholder="手机号/用户名" name="username">
							<i slot="prefix" class="el-input__icon el-icon-user-solid"></i></el-input>
						<el-input class="el-input-css" type="password" v-show="isPwdLogin" v-model="logindata.password" placeholder="请输入密码" name="password"><i slot="prefix" class="el-input__icon el-icon-lock"></i></el-input>
						<div class="verification oh" v-show="!isPwdLogin">
							<el-input type="text" style="width: 60%;" v-model="logindata.code" @keydown="inputInDown" class="el-input-css fl" placeholder="请输入验证码" name="password"></el-input>
							<el-button class="verification-code-btn fr ml-1" style="width: 35%;height: 40px" size="medium" :disabled="codeSecond>0" @click="sendCode">获取验证码<span v-show="codeSecond>0">({{codeSecond}})</span></el-button>
						</div> -->
						<div v-if="isPwdLogin">
							<!-- <div class="login-line">
									<input type="text" v-model="logindata.username" @keydown="inputInDown" class="underlinput underlinput1 username" :placeholder="isPwdLogin?'请输入用户名':'请输入手机号'" name="username">
								</div> -->
							<el-input class="el-input-css mb-2" v-model="logindata.username" placeholder="手机号/用户名"
								name="username">
								<i slot="prefix" class="el-input__icon el-icon-user-solid"></i></el-input>
							<el-input class="el-input-css" type="password" v-model="logindata.password"
								placeholder="请输入密码" name="password"><i slot="prefix"
									class="el-input__icon el-icon-lock"></i></el-input>

							<!-- v-show="!logindata.isPhoneNumber || !isSmsLogin" -->
							<!-- <div class="login-line">
								<input type="password" v-model="logindata.password" @keydown="inputInDown" class="underlinput underlinput1 password" placeholder="请输入密码" name="password">
							</div> -->
						</div>
						<div v-else>
							<!-- v-show="logindata.isPhoneNumber && isSmsLogin" -->
							<el-input class="el-input-css mb-2" v-model="logindata.phone" placeholder="请输入手机号"
								name="username">
								<i slot="prefix" class="el-input__icon el-icon-user-solid"></i></el-input>
							<div class="verification oh">
								<el-input type="text" style="width: 60%;" v-model="logindata.code"
									@keydown="inputInDown" class="el-input-css fl" placeholder="请输入验证码"
									name="password"></el-input>
								<el-button class="verification-code-btn fr ml-1" style="width: 35%;height: 40px"
									size="medium" :disabled="codeSecond > 0" @click="sendCode">获取验证码<span
										v-show="codeSecond > 0">({{ codeSecond }})</span></el-button>
							</div>
						</div>
						<button type="submit" class="submitbtn" @click="passwordLogin()">登录</button>
						<p class="errortext mgax">{{ errortext }}</p>
					</div>
					<p class="text-center font-24 pb-3 pt-5">精准招商 数据领航 —开启智能产业新纪元</p>
					<p class="text-center font-24">全球招商 共创无限可能</p>
					<div class="flexcss">
						<div>政务合作：133 8110 9559</div>
						<div>商务邮箱：luckcloudsh@163.com</div>
						<div>机构合作：158 0070 7559</div>
						<div>&nbsp;&nbsp;投诉邮箱：luckcloud110@163.com</div>
					</div>
				</div>
			</div>
			<div class="login-center" v-if="curWebsite.type != 7 && curWebsite.type != 2">
				<div class="loginLogoBox oh"
					:style="curWebsite.type == 8 ? 'padding-left:0;width:600px;text-align:center;margin:0' : ''">
					<!--  :style="curWebsite.type == 6?'padding-left:0;':''" -->
					<img src="@/assets/images/zt_logo_sm2.png" v-if="curWebsite.type != 8 && curWebsite.type != 9"
						alt="中投顾问" class="loginlogo fl" :style="curWebsite.type == 6 ? 'margin-top:5px' : ''">
					<img src="@/assets/images/SIMA_logo.png" v-if="curWebsite.type == 9" alt="中投顾问" class="loginlogo fl"
						style="width: 74px;height: 74px">
					<h2 id="logoTitle" :class="curWebsite.type != 8 ? 'fl' : ''">
						<span class="website-company" v-if="curWebsite.type == 6"> 中投大数据</span>
						<span id="logoTitle1">{{ curList.name }}</span> <br>
						<span class="opEnglish">Industrial Merchants Brain</span>
					</h2>
				</div>
				<div class="clear"></div>
				<div class="left-font">
					<h3 class="title" id="weisite-title">{{ curList.title }}</h3>
					<ul id="font-list">
						<li :key="index" v-for="(item, index) in curList.fontlist">{{ item }}</li>
					</ul>
					<p class="yellowfont">……所有工作，只需点击几下鼠标就完成</p>
				</div>
				<div class="rightlogin">
					<div class="loginblock">
						<h4 class="login-form-title">账户登录</h4>
						<div class="oh widthPC-90 margin-x-auto">
							<span class="fl login_type" :class="!isPwdLogin ? 'active' : ''"
								@click="isPwdLogin = false; errortext = ''"> 短信验证码登录 </span>
							<span class="fr login_type" :class="isPwdLogin ? 'active' : ''"
								@click="isPwdLogin = true; errortext = ''">账号密码登录 </span>
						</div>
						<div class="login-form">
							<div v-if="isPwdLogin">
								<div class="login-line">
									<input type="text" v-model="logindata.username" @keydown="inputInDown"
										class="underlinput underlinput1 username"
										:placeholder="isPwdLogin ? '请输入用户名' : '请输入手机号'" name="username">
								</div>
								<!-- v-show="!logindata.isPhoneNumber || !isSmsLogin" -->
								<div class="login-line">
									<input type="password" v-model="logindata.password" @keydown="inputInDown"
										class="underlinput underlinput1 password" placeholder="请输入密码" name="password">
								</div>
							</div>
							<div v-else>
								<!-- v-show="logindata.isPhoneNumber && isSmsLogin" -->
								<div class="login-line">
									<input type="text" v-model="logindata.phone" @keydown="inputInDown"
										class="underlinput underlinput1 username"
										:placeholder="isPwdLogin ? '请输入用户名' : '请输入手机号'" name="phone">
								</div>
								<div class="login-line verification">
									<input type="text" v-model="logindata.code" @keydown="inputInDown"
										class="underlinput underlinput1 password" placeholder="请输入验证码" name="password">
									<el-button class="verification-code-btn" size="medium" :disabled="codeSecond > 0"
										@click="sendCode">获取验证码<span
											v-show="codeSecond > 0">({{ codeSecond }})</span></el-button>
								</div>
							</div>

							<!-- <div>&nbsp;<br>&nbsp;</div> -->
							<button type="submit" class="loginsubmit submitbtn" @click="passwordLogin()">登录</button>

							<!-- <button type="submit" class="loginsubmit submitbtn" v-show="curList.type==6" >登录</button> -->
						</div>
						<p class="errortext">{{ errortext }}</p>
					</div>
				</div>
				<p class="clear"></p>
				<div class="btnbox tac" v-if="curWebsite.type == 1 && !demonstrate">
					<a href="http://c.ocn.com.cn/special/investmentpage/investmentpage-cydn.htm" class=""
						target="_blank">产品介绍 ></a>
					<a href="http://c.ocn.com.cn/special/cydnProduct/" class="" target="_blank">十大功能 ></a>
					<a href="#login-service" class="">服务方式 ></a>
				</div>
			</div>
		</div>

		<!-- <div class="login-introduction" id="login-introduction" v-if="curWebsite.type == 2">
			<div :class="isScroll ? 'titlebox tac scroll-titlebox' : 'titlebox tac'">
				<strong>产业治理大脑</strong><span>核心功能介绍</span><i class="godownpng"></i>
			</div>
			<table border="0" cellspacing="0" cellpadding="0" class="login-table">
				<tr>
					<th colspan="2">发改、工信等部门工作场景</th>
					<th>功能说明</th>
				</tr>
				<tr>
					<td>
						<h5 class="title">产业研究</h5>
					</td>
					<td class="midBorder">
						<span class="db">查看全国产业图谱</span><span class="db">诊断本地产业链</span><span
							class="db">查看行业研究报告</span><span class="db">查看产业投资大数据</span>
					</td>
					<td>
						<p>有<strong>240多条产业链全国图谱</strong>，高效查找产业链各环节重点企业，并随时查看企业详细信息</p>
						<p>自动诊断<strong>本地产业链强链补链环节</strong>，查看本地重点企业详情</p>
						<p>覆盖所有重点、热点行业 ，<strong>900多份深度行业研究报告</strong>，随时在线查看阅读</p>
						<p>国内独家的<strong>上市公司投资数据库、企业拿地投资数据库</strong>，可以进行各种组合高级查询</p>
					</td>
				</tr>
				<tr>
					<td>
						<h5 class="title">产业招商</h5>
					</td>
					<td class="midBorder">
						<span class="db">招大引强</span><span class="db">招新引优</span><span class="db">吸引外资</span>
					</td>
					<td>
						<p>500强、央企、国企、上市公司、链主企业、制造业单项冠军，所有<strong>行业龙头企业</strong>一网打尽</p>
						<p>最新获得融资的科创企业、专精特新企业、新三板企业、雏鹰企业等，<strong>全国所有新兴科技企业</strong>任挑选</p>
						<p>13.7万家<strong>外商投资企业</strong>、3.8万家<strong>境外上市企业</strong>(即<strong>全球所有上市公司</strong>)，可高效筛选，能查看详情
						</p>
					</td>
				</tr>
				<tr>
					<td>
						<h5 class="title">智能推荐</h5>
					</td>
					<td class="midBorder">
						<span class="db">企业投资窗口期</span><span class="db">产业投资窗口期</span><span
							class="db">产业链招商推荐</span><span class="db">以商招商推荐</span>
					</td>
					<td>
						<p>处于大额融资后、高增长及拟上市等时期，企业有旺盛的投资需求，也就是政府最容易招引的时机:</p>
						<p>处于旺盛投资期的产业是政府产业发展的最佳机会，所以，<strong>产业投资窗口期</strong>就是政府产业发展的窗口期</p>
						<p>根据本地主导产业、新兴产业方向设置产业标签，系统根据标签<strong>自动推荐目标招商企业</strong></p>
						<p>分析本地龙头上市公司的上下游企业、周边城市龙头企业的上下游企业，然后进行<strong>以商招商</strong></p>
					</td>
				</tr>
			</table>
		</div>
		<div class="login-introduction service-introduction" id="login-service" v-if="curWebsite.type == 2">
			<div class="titlebox tac">
				<strong>产业治理大脑</strong><span>服务方式介绍</span>
			</div>
			<table border="0" cellspacing="0" cellpadding="0" class="login-table">
				<tr>
					<th colspan="2">服务方式</th>
					<th>收费方式</th>
				</tr>
				<tr>
					<td>
						<h5 class="title">1.在线服务</h5>
					</td>
					<td class="midBorder">云端在线SaaS服务，最为便捷，开通账号即可使用；免维护、成本低、功能全、迭代快</td>
					<td class="font-size18">按账号收年度服务费</td>
				</tr>
				<tr>
					<td>
						<h5 class="title">2.数据服务</h5>
					</td>
					<td class="midBorder">通过API 接口为用户提供数据服务，可以与用户已有产业管理系统无缝对接，开发周期1-2个月</td>
					<td class="font-size18">每年数据使用费</td>
				</tr>
				<tr>
					<td>
						<h5 class="title">3.定制服务</h5>
					</td>
					<td class="midBorder">定制开发某城市产业治理大脑或某产业治理大脑，网站域名及界面都可定制，开发周期1-3个月</td>
					<td class="font-size18">开发费 + 年度维护费</td>
				</tr>
			</table>
			<p class="login-induction-font-sm">
				说明：以上服务，只与政府、园区、平台公司等最终用户签约合作；第三方信息化公司可作为技术服务机构，协助用户现有产业管理系统与我们的数据系统进行技术对接。</p>
		</div> -->
		<div class="login-introduction" id="login-introduction" v-if="curWebsite.type == 4">
			<div :class="isScroll ? 'titlebox tac scroll-titlebox' : 'titlebox tac'">
				<strong>产业信贷大脑</strong><span>核心功能介绍</span><i class="godownpng"></i>
			</div>
			<table border="0" cellspacing="0" cellpadding="0" class="login-table">
				<tr>
					<th colspan="2">信贷业务工作场景</th>
					<th>功能说明</th>
				</tr>
				<tr>
					<td>
						<h5 class="title">选产业</h5>
					</td>
					<td class="midBorder">
						<span class="db">产业投资窗口期-选产业</span><span class="db">筛选城市支柱产业-选产业</span><span
							class="db">行业报告库看产业-选产业</span>
					</td>
					<td>
						<p>通过大数据筛选出当前处于<strong>投资(融资)窗口期的行业</strong>，作为重点业务方向参考</p>
						<p>通过企业大数据，筛选出本城市或其他城市的<strong>支柱产业</strong>，作为业务方向参考</p>
						<p>报告库共有<strong>900多份行业研究报告</strong>，覆盖所有重点热点行业，便于快速了解行业</p>
					</td>
				</tr>
				<tr>
					<td>
						<h5 class="title">找企业</h5>
					</td>
					<td class="midBorder">
						<span class="db">园区楼宇-找企业</span>
						<span class="db">产业链图谱-找企业</span>
						<span class="db">产业链金融-找企业</span><span class="db">投贷联动-找企业</span><span
							class="db">企业投资窗口期-找企业</span><span class="db">根据投资排行榜-找企业</span>
					</td>
					<td>
						<p>通过<strong>全市所有园区和楼宇</strong>的搜索，筛查有实力的和发展中的优质企业客户资源</p>
						<p>从<strong>全国产业图谱</strong>找行业龙头企业;从<strong>本市产业链图谱</strong>，找本市产业链各环节企业</p>
						<p>根据<strong>本地龙头企业上下游名单</strong>，查找被龙企业带动的受益的产业链上下游企业</p>
						<p>企业获投资充实资本金后，就有资信获得配套信贷支持，<strong>实现投资和贷款联动</strong></p>
						<p>业绩高速成长、获大额融资或拟上市的企业，处于投资扩张期，信贷需求自然强烈</p>
						<p>频繁拿地投资、以及投资项目多的企业，融资的需求自然大，所以是<strong>重要信贷客户</strong></p>
					</td>
				</tr>
				<tr>
					<td>
						<h5 class="title">做研判</h5>
					</td>
					<td class="midBorder">
						<span class="db">研判企业融资需求</span>
					</td>
					<td>
						<p>算法逻辑，行业有大机会，龙头企业一定会投资，所以就有融资需求</p>
					</td>
				</tr>
				<tr>
					<td>
						<h5 class="title">建联系</h5>
					</td>
					<td class="midBorder">
						<span class="db">企业-企业 关系计算器</span>
					</td>
					<td>
						<p>通过认识的企业，计算与目标企业的关系链，再让中间企业介绍，联系目标企业</p>
					</td>
				</tr>
			</table>
			<ul class="login-induction-font">
				<li><strong>产品价值：</strong>让金融机构的企业信贷部门<span
						class="basefont-nocur">精准选择风口产业、快速查找产业链重点企业、高效挖掘有信贷需求的优质企业</span></li>
				<li><strong>服务方案：</strong><span>产业信贷大脑 + 产品使用培训（即大数据精准挖掘方法培训，确保全员掌握） + 后续服务</span></li>
			</ul>
		</div>
		<div class="login-introduction service-introduction" id="login-service" v-if="curWebsite.type == 4">
			<div class="titlebox tac ">
				<strong>产业信贷大脑</strong><span>服务方式介绍</span>
			</div>
			<table border="0" cellspacing="0" cellpadding="0" class="login-table">
				<tr>
					<th colspan="2">服务方式</th>
					<th>收费方式</th>
				</tr>
				<tr>
					<td>
						<h5 class="title">1.在线服务</h5>
					</td>
					<td class="midBorder">云端在线SaaS服务，最为便捷，开通账号即可立即使用；免维护、成本低、功能全、迭代快</td>
					<td class="font-size18">按账号收年度服务费</td>
				</tr>
				<tr>
					<td>
						<h5 class="title">2.数据服务</h5>
					</td>
					<td class="midBorder">通过API 接口为用户提供数据服务，可以与用户已有客户管理系统无缝对接，开发周期1-2个月</td>
					<td class="font-size18">每年数据使用费</td>
				</tr>
				<tr>
					<td>
						<h5 class="title">3.定制服务</h5>
					</td>
					<td class="midBorder">定制开发某城市产业信贷大脑或某产业信贷大脑，网站域名及界面都可定制，开发周期1-3个月</td>
					<td class="font-size18">开发费 + 年度维护费</td>
				</tr>
			</table>
			<p class="login-induction-font-sm">
				说明：以上服务，只与银行、保险公司、金融租赁公司、信托公司等最终用户签约合作；第三方信息化公司可以作为技术服务机构，协助用户现有客户管理系统与我们的数据系统进行技术对接。</p>
		</div>

		<div class="login-introduction" id="login-introduction" ref="introduction1"
			:style="curWebsite.type == 2 ? 'margin:0 auto;background:#f4f6fa' : ''"
			v-if="curWebsite.type == 6 || curWebsite.type == 2">
			<div :class="isScroll ? 'titlebox tac scroll-titlebox' : 'titlebox tac'">
				<strong>产业研究大脑</strong><span>核心功能介绍</span>
				<a href="https://chanyeyanjiu.cn/#/totalEnterprises" target="_blank" class="link-teak"
					v-show="curWebsite.type == 2">访问体验版 > </a><i class="godownpng"></i>
			</div>
			<table border="0" cellspacing="0" cellpadding="0" class="login-table">
				<tr>
					<th colspan="2">产业研究工作场景</th>
					<th>功能说明</th>
				</tr>
				<tr>
					<td>
						<h5 class="title">做产业研究</h5>
					</td>
					<td class="midBorder">
						<span class="db">深度产业研究</span><span class="db">产业链研究</span><span class="db">投资趋势研究</span>
					</td>
					<td>
						<p>覆盖所有重点、热点行业，<strong>1000多份深度行业研究报告</strong>，可随时在线阅读，全面深入理解各个行业</p>
						<p>有<strong>240多条产业链图谱</strong>，能高效查找产业链各环节重点企业，并随时查看企业详细信息，产业链全景一览无余</p>
						<p>通过独家<strong>上市公司投资数据库、企业拿地投资数据库</strong>，把握各个产业投资趋势，分析龙头企业投资动向</p>
					</td>
				</tr>
				<tr>
					<td>
						<h5 class="title">做企业研究</h5>
					</td>
					<td class="midBorder">
						<span class="db">上市公司研究</span><span class="db">龙头企业研究</span><span class="db">创新企业研究</span><span
							class="db">外资企业研究</span>
					</td>
					<td>
						<p>通过<strong>5200多家A股上市企业库</strong>，高效查找各行业、各地区上市公司数据，并查看企业战略方向和投资布局；</p>
						<p>有包括<strong>500强、央企、国企在内的5万多家（非A股上市）龙头企业</strong>，查看每家企业投资动态和投资布局</p>
						<p><strong>7万多家获得融资的创新企业库</strong>，可以分地区、分行业进行高级查询，快速查找优质投资标的</p>
						<p>高效查找13万家外资企业、以及1600多家外资企业总部，查看该企业在国内的投资布局和投资动态</p>
					</td>
				</tr>
				<tr>
					<td>
						<h5 class="title">监测产业动态</h5>
					</td>
					<td class="midBorder">
						<span class="db">创新企业融资动态</span><span class="db">专业机构投资动态</span><span
							class="db">上市公司投资动态</span><span class="db">企业拿地投资动态</span>
					</td>
					<td>
						<p>查看最近12个月，<strong>每个月最新获得融资的科技型创新企业</strong>，可分阶段、分城市查询</p>
						<p>查找全国所有<strong>一级市场专业投资机构</strong>，并查看每家机构的<strong>投资方向和最新投资项目</strong>；可分城市、分行业查询</p>
						<p>实时监测所有上市公司公告的<strong>最新投资项目</strong>，对本行业标杆企业的的<strong>投资动态</strong>一目了然</p>
						<p>动态监测所有企业的<strong>拿地投资动态</strong>，对行业重点企业的<strong>投资布局、产能扩张动态</strong>全面掌握</p>
					</td>
				</tr>
				<tr>
					<td>
						<h5 class="title">产业排行榜</h5>
					</td>
					<td class="midBorder">
						<span class="db">重点产业城市排行</span><span class="db">热点产业企业排行</span><span
							class="db">重点城市产业排行</span><span class="db">重点区域企业排行</span>
					</td>
					<td>
						<p>通过产业、企业大数据，在选定重点产业后，对全国重点城市进行排行，各城市产业竞争格局，一目了然</p>
						<p>通过产业、企业大数据，选定任何区域、任何城市、任何产业，都可以立即自动对企业进行智能排序</p>
						<p>通过产业、企业大数据，对国内前20个重点城市，自动分析每个城市重点产业，及该产业的重点企业数量</p>
						<p>对长三角、珠|三角、京津冀、成渝及闽东南5个重点区域及相关城市进行分析，智能筛选出重点龙头企业</p>
					</td>
				</tr>
			</table>
			<ul class="login-induction-font">
				<li><strong>产品价值：</strong><span>让研究机构、政府和企业的研究部门高效进行产业研究、企业研究，随时掌握相关行业动态</span></li>
				<li><strong>服务方案：</strong><span>产业研究大脑 + 产品使用培训（即大数据高效研究方法培训，确保全员掌握） + 后续服务</span></li>
			</ul>
		</div>
		<div class="login-introduction service-introduction" ref="service1"
			:style="curWebsite.type == 2 ? 'margin:0 auto;background:#f4f6fa' : ''" id="login-service"
			v-if="curWebsite.type == 6 || curWebsite.type == 2">
			<div class="titlebox tac ">
				<strong>产业研究大脑</strong><span>服务方式介绍</span>
			</div>
			<table border="0" cellspacing="0" cellpadding="0" class="login-table">
				<tr>
					<th colspan="2">服务方式</th>
					<th>收费方式</th>
				</tr>
				<tr>
					<td>
						<h5 class="title">1.在线服务</h5>
					</td>
					<td class="midBorder">云端在线SaaS服务，最为便捷，开通账号即可立即使用；免维护、成本低、功能全、迭代快</td>
					<td class="font-size18">按账号收年度服务费</td>
				</tr>
				<tr>
					<td>
						<h5 class="title">2.数据服务</h5>
					</td>
					<td class="midBorder">通过API 接口为用户提供数据服务，可以与用户已有客户管理系统无缝对接，开发周期1-2个月</td>
					<td class="font-size18">每年数据使用费</td>
				</tr>
				<tr>
					<td>
						<h5 class="title">3.定制服务</h5>
					</td>
					<td class="midBorder">定制开发某城市产业研究大脑或某产业研究大脑，网站域名及界面都可定制，开发周期1-3个月</td>
					<td class="font-size18">开发费 + 年度维护费</td>
				</tr>
			</table>
			<p class="login-induction-font-sm">
				说明：以上服务，只与政府、企业、大学、研究机构等最终用户签约合作；第三方信息化公司可作为技术服务机构，协助用户现有研究管理系统与我们的数据系统进行技术对接。</p>
		</div>
		<div class="login-introduction" id="login-introduction" ref="introduction2"
			v-if="curWebsite.type == 5 || curWebsite.type == 2">
			<div :class="isScroll ? 'titlebox tac scroll-titlebox' : 'titlebox tac'">
				<strong>产业投资大脑</strong><span>核心功能介绍</span>
				<a href="https://www.chanyetouzi.com/#/totalEnterprises" target="_blank" class="link-teak"
					v-show="curWebsite.type == 2">访问体验版 > </a><i class="godownpng"></i>
			</div>
			<table border="0" cellspacing="0" cellpadding="0" class="login-table">
				<tr>
					<th colspan="2">企业战略投资工作场景</th>
					<th>功能说明</th>
				</tr>
				<tr>
					<td>
						<h5 class="title">看投资动态</h5>
					</td>
					<td class="midBorder">
						<span class="db">创新企业融资动态</span><span class="db">专业机构投资动态</span><span
							class="db">上市公司投资动态</span><span class="db">企业拿地投资动态</span>
					</td>
					<td>
						<p>查看最近12个月，<strong>每个月最新获得融资的科技型创新企业，</strong>可分阶段、分城市查询；</p>
						<p>查找全国所有<strong>专业投资机构，</strong>查看每家机构的<strong>投资方向和最新投资项目，</strong>可分城市、分行业查询；</p>
						<p>实时监测所有上市公司公告的 ，<strong>最新投资项目</strong>对行业标杆企业的<strong>投资动态</strong>一目了然；</p>
						<p>动态监测所有企业的<strong>拿地投资动态</strong>对行业重点企业的<strong>投资布局、产能扩张动态</strong>全面掌握；</p>
					</td>
				</tr>
				<tr>
					<td>
						<h5 class="title">做产业研究</h5>
					</td>
					<td class="midBorder">
						<span class="db">查看行业研究报告</span><span class="db">查看产业链图谱</span><span
							class="db">查看产业投资大数据</span><span class="db">查看对标企业</span>
					</td>
					<td>
						<p>覆盖所有重点、热点行业，<strong>1000多份深度行业研究报告</strong>，随时在线阅读，快速全面了解一个新行业；</p>
						<p>有<strong>260多条产业链图谱</strong>，高效查找产业链各环节重点企业，并随时查看企业详细信息；</p>
						<p>独家<strong>上市公司投资数据库、企业拿地投资数据库</strong>可以进行各种组合高级查询，透视产业投资最新动态</p>
						<p>通过看<strong>上市公司库、龙头企业库、外资企业库</strong>，掌握对标企业的投资动态及投资布局；</p>
					</td>
				</tr>
				<tr>
					<td>
						<h5 class="title">找投资标的</h5>
					</td>
					<td class="midBorder">
						<span class="db">创新企业库-找标的</span><span class="db">优质企业库-找标的</span>
					</td>
					<td>
						<p>查找<strong>天使轮、种子轮、ABCD各轮次获得融资</strong>的科技型企业，可以分城市、分行业高效查询；</p>
						<p>查找带<strong>专精特新企业、雏鹰企业、高新技术企业</strong>等科技标签的企业，可分城市、分行业查找；</p>
					</td>
				</tr>
				<tr>
					<td>
						<h5 class="title">查智能推荐</h5>
					</td>
					<td class="midBorder">
						<span class="db">智能推荐投资标的</span><span class="db">智能推荐投资机构</span>
					</td>
					<td>
						<p>根据企业用户关注的<strong>新兴产业方向</strong>设置标签，系统自动<strong>新兴产业方向</strong>智能推荐最新投资标的；</p>
						<p>根据用户关注的<strong>产业方向标签，</strong>系统<strong>自动推荐相关产业的专业投资机构，</strong>掌握机构最新投资动态；</p>
					</td>
				</tr>
			</table>
		</div>
		<div class="login-introduction service-introduction" ref="service2" id="login-service"
			v-if="curWebsite.type == 5 || curWebsite.type == 2">
			<div class="titlebox tac ">
				<strong>产业投资大脑</strong><span>服务方式介绍</span>
			</div>
			<table border="0" cellspacing="0" cellpadding="0" class="login-table">
				<tr>
					<th colspan="2">服务方式</th>
					<th>收费方式</th>
				</tr>
				<tr>
					<td>
						<h5 class="title">1.在线服务</h5>
					</td>
					<td class="midBorder">云端在线SaaS服务，最为便捷，开通账号即可立即使用；免维护、成本低、功能全、迭代快</td>
					<td class="font-size18">按账号收年度服务费</td>
				</tr>
				<tr>
					<td>
						<h5 class="title">2.数据服务</h5>
					</td>
					<td class="midBorder">通过API 接口为用户提供数据服务，可以与用户已有客户管理系统无缝对接，开发周期1-2个月</td>
					<td class="font-size18">每年数据使用费</td>
				</tr>
				<tr>
					<td>
						<h5 class="title">3.定制服务</h5>
					</td>
					<td class="midBorder">定制开发某产业投资大脑或某企业投资大脑，网站域名及界面都可定制，开发周期1-3个月</td>
					<td class="font-size18">开发费 + 年度维护费</td>
				</tr>
			</table>
			<p class="login-induction-font-sm">
				说明：以上服务，只与企业集团、企业、投资机构等最终用户签约合作；第三方信息化公司可以作为技术服务机构，协助用户现有客户管理系统与我们的数据系统进行技术对接。</p>
		</div>
		<div class="login-introduction" id="login-introduction" ref="introduction3"
			:style="curWebsite.type == 2 ? 'margin:0 auto;background:#f4f6fa' : ''"
			v-if="(curWebsite.type == 1 || curWebsite.type == 8 || curWebsite.type == 9 || curWebsite.type == 2) && !demonstrate">
			<div :class="isScroll ? 'titlebox tac scroll-titlebox' : 'titlebox tac'">
				<strong>{{ curWebsite.type == 7 ? '上海产业运算大数据平台' : '产业招商大脑' }}</strong><span>核心功能介绍</span>
				<a href="https://www.zhaoshangdanao.com/#/totalEnterprises" target="_blank" class="link-teak"
					v-show="curWebsite.type == 2">访问体验版 > </a>
				<i class="godownpng" v-show="curWebsite.type == 1"></i>
			</div>
			<table border="0" cellspacing="0" cellpadding="0" class="login-table">
				<tr>
					<th colspan="2">招商工作场景</th>
					<th>功能说明</th>
				</tr>
				<tr>
					<td>
						<h5 class="title">看机会</h5>
					</td>
					<td class="midBorder"><span class="db">产业投资-招商机会</span><span class="db">产业转移-招商机会</span><span
							class="db">企业投资-招商机会</span></td>
					<td>
						<p>监测<strong>重点产业的上市公司投资动态、企业拿地动态</strong>，发现产业招商机会</p>
						<p>监测<strong>发达省份、城市的产业转移动态</strong>，发现区域产业转移招商机会</p>
						<p>监测<strong>龙头企业拿地投资动态</strong>，挖掘重点行业龙头招商机会</p>
					</td>
				</tr>
				<tr>
					<td>
						<h5 class="title">找企业</h5>
					</td>
					<td class="midBorder"><span class="db">产业链招商-找企业</span><span class="db">驻点招商-找企业</span><span
							class="db">资本招商-找企业</span></td>
					<td>
						<p>从<strong>全国产业图谱</strong>找龙头企业；自动诊断<strong>本地产业链</strong>，找强链补链目标招商企业</p>
						<p>在北上广深等重点城市招商，<strong>快速锁定重点产业和龙头企业</strong></p>
						<p>快速查找<strong>专业投资机构</strong>及其投资方向；及时查找<strong>最新获投创新企业</strong></p>
					</td>
				</tr>
				<tr>
					<td>
						<h5 class="title">做研判</h5>
					</td>
					<td class="midBorder"><span class="db">研判企业投资意向</span><span class="db"></span><span
							class="db">评估企业投资实力</span></td>
					<td>
						<p>看业务和产品，看实际投资项目，看投资概率，<strong>判断投资意向</strong></p>
						<p>分析投资布局、分析上下游企业、分析科技创新实力，<strong>评估投资实力</strong></p>
					</td>
				</tr>
				<tr>
					<td>
						<h5 class="title">建联系</h5>
					</td>
					<td class="midBorder"><span class="db">企业-企业 关系计算器</span><span class="db">企业-城市 关系计算器</span><span
							class="db"></span></td>
					<td>
						<p>通过认识的企业，计算与目标企业的关系链，再让中间企业介绍，联系目标企业</p>
						<p>通过本城市的企业，计算与目标企业的关系链，让本地企业牵线搭桥、以商招商</p>
					</td>
				</tr>
			</table>
			<ul class="login-induction-font">
				<li><strong>服务效果：</strong><span>让全市（区、县、园区）参与招商的所有队伍，从传统招商方式，升级为大数据精准招商方式</span></li>
				<li><strong>服务方案：</strong><span>产业招商大脑 + 产品使用培训（即大数据精准招商方法培训，确保全员掌握） + 后续专业服务</span></li>
			</ul>
		</div>
		<div class="login-introduction service-introduction" ref="service3" id="login-service"
			:style="curWebsite.type == 2 ? 'margin:0 auto;background:#f4f6fa' : ''"
			v-if="curWebsite.type == 1 || curWebsite.type == 9 || curWebsite.type == 2">
			<div class="titlebox tac">
				<strong>产业招商大脑</strong><span>服务方式介绍</span>
			</div>
			<table border="0" cellspacing="0" cellpadding="0" class="login-table">
				<tr>
					<th colspan="2">服务方式</th>
					<th>收费方式</th>
				</tr>
				<tr>
					<td>
						<h5 class="title">1.在线服务</h5>
					</td>
					<td class="midBorder">云端在线SaaS服务，最为快捷，开通账号即可立即使用；开通快、成本低、功能强、免维护 </td>
					<td class="font-size18">按账号收年度服务费</td>
				</tr>
				<tr>
					<td>
						<h5 class="title">2.数据服务</h5>
					</td>
					<td class="midBorder">通过API 接口为用户提供数据服务，可以与用户已有招商管理系统无缝对接，开发周期1-2个月</td>
					<td class="font-size18">每年数据使用费</td>
				</tr>
				<tr>
					<td>
						<h5 class="title">3.定制服务</h5>
					</td>
					<td class="midBorder">定制开发某城市招商大脑或某产业招商大脑，网站域名及界面都可定制，开发周期1-3个月</td>
					<td class="font-size18">开发费 + 年度维护费</td>
				</tr>
			</table>
			<p class="login-induction-font-sm">
				说明：以上服务，只与政府、园区、平台公司等最终用户签约合作；第三方信息化公司可作为技术服务机构，协助用户现有招商管理系统与我们的数据系统进行技术对接。</p>
		</div>
		<div class="login-introduction " id="aboutUs" v-if="!demonstrate && curList.type != 8">
			<div class="login-company-introduction" v-if="curList.type != 7">
				<div class="titlebox tac scroll-titlebox" style="margin-bottom: 0;">
					<strong>公司介绍</strong>
				</div>
				<p v-if="curList.type != 6 && curList.type != 9">
					中投顾问下属单位“深圳市中投产业经济咨询有限公司”负责运营和专业支持，“深圳市中投大数据科技有限公司”提供技术支持，隆重推出系列数字化产品：产业大脑。</p>
				<div v-if="curList.type == 9">
					<p>深圳市企业并购促进会与中投顾问联合推出系列数字化产品：产业大脑。</p>
					<p>深圳市企业并购促进会(SIMA)是由在深交所与港交所及其它公开市场挂牌的上市公司，产业链头部企业、深港银行证券投行投资等金融企业、各类创新型中小企业、高校及科研机构、行业组织等联合发起的产业集约化发展促进机构。深圳市企业并购促进会(SIMA)致力从环境、社会和公司治理(ESG)维度为政府(社会)、大企业和小企业(GBSME)各方的共赢与可持续发展提供符合市场逻辑的解决方案。在上市公司、产业链头部企业与中小企业之间，在产业链上下游企业之间，在产业资本与金融资本之间以及在政府、企业、资本、交易所、专业服务。
					</p>
				</div>
				<p v-if="curList.type == 6">中投顾问下属单位“深圳市中投大数据科技有限公司”负责运营和专业支持， 隆重推出系列数字化产品：产业大脑。</p>
				<p>中投顾问于2002年在深圳成立，是中国领先的产业研究与产业战略咨询机构。20多年来，中投顾问一直聚焦在“产业”领域，专注于产业研究、产业规划、产业招商及产业投资咨询服务。中投顾问是国内唯一一家既有深厚的产业研究背景，又只专注于产业投资与产业发展服务的专业公司。对政府以及园区，中投顾问提供从产业规划、产业招商、产业基金以及产业资源导入的一体化产业发展咨询解决方案；对企业，中投顾问提供投资机会研究、投资地点选择、项目策划设计的一体化产业投资咨询服务。
				</p>
				<p>依托对政府和企业客户需求的深刻洞察，以及我们十几年积累的大数据资源，中投顾问全力打造了产业发展和产业投资多种场景的数字化工具：<strong>产业大脑</strong>。</p>
				<p>针对企业的战略投资工作场景，开发了<strong>产业投资大脑</strong>；</p>
				<p>针对政府和园区的招商引资工作场景，推出了<strong>产业招商大脑</strong>；</p>
				<p>针对政府的发改、工信等产业治理部门，推出了<strong>产业治理大脑</strong>； </p>
				<p>针对银行、融资租赁公司等金融机构，推出了<strong>产业信贷大脑</strong>；</p>
				<p>针对大学、研究机构、政府和企业的研究部门，推出了<strong>产业研究大脑</strong>；</p>
				<p>我们充分挖掘大数据支撑决策的潜力，把数字化的工具和专业的研究咨询能力结合，为政产学研金服用的产业生态提供可落地的专业服务。</p>
			</div>
			<div class="login-company-introduction" style="text-indent: inherit;" v-if="curList.type == 7">
				<h1 class="text-center mb-2 mt-8">【天枢云脑Cerebro Synapse】全球产业赋能平台 </h1>
				<h3 class="text-center mb-2">——华为云昇腾AI生态战略伙伴|深度求索(DeepSeek)技术融合创新</h3>
				<dl>
					<dt class="font-weight">定位愿景</dt>
					<dd>立足上海国际金融中心,以上海国际数字枢纽为基座,依托华为云昇腾A|算力集群与深度求索认知推理引擎,构建“云脑+产业+生态”三位一体的全球化产业智能操作系统,驱动全要素生产力革新构建全球产业经济智慧中枢,以前沿数字科技驱动产业集群协同创新,赋能城市产业生态转型升级
					</dd>
				</dl>
				<dl class="mt-3">
					<dt class="font-weight">核心优势</dt>
					<dd>
						技术引领:集成大数据+AI大模型(ChatGPT技术深度应用)+云计算,打造中国首个产业级SaaS融合平台<br />
						资源网络:链接全球40+核心产业带,覆盖500+智库机构与财经媒体矩阵<br />
						决策赋能:实时追踪120+国家产业政策,构建万亿级产业投资动态数据库
					</dd>
				</dl>
				<dl class="mt-3">
					<dt class="font-weight">技术支撑</dt>
					<dd>
						智能决策引擎:AI驱动产业图谱分析,精准捕捉全球投资机遇<br />
						数字孪生系统:云计算支撑产业集群虚拟仿真<br />
						认知智能中枢:NLP技术实现政策语义深度解析
					</dd>
				</dl>
				<dl class="mt-3">
					<dt class="font-weight">服务价值</dt>
					<dd>
						【政企投资全周期解决方案】<br />
						1.产业智库:全球顶尖专家网络+可视化决策模型<br />
						2.资本对接:智能匹配全球产业资本与优质项目<br />
						3.数据洞察:实时监控产业链供需波动与风险预警<br />
						4.生态构建:跨地域产业集群协同创新平台<br />
						【价值承诺】<br />
						通过「技术+数据+生态」三维赋能,助力政府提升产业治理效能,帮助企业降低决策风险40%+,加速科技成果转化周期,实现区域经济高质量可持续发展
					</dd>
				</dl>
			</div>
		</div>

		<div class="loginfooter pt-1" style="background-color: #eee;">
			<div v-if="curWebsite.type != 7 && curWebsite.type != 8">
				<p> 深圳市中投顾问有限责任公司</p>
				<p>服务热线:400-008-0552&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;0755-8257 1568</p>
				<p>地址:广东省深圳市福田区车公庙泰然六路雪松大厦A座4楼</p>
				<p>专业支持：深圳市中投产业经济咨询有限公司&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;技术支持：深圳市中投大数据科技有限公司</p>
			</div>
			<div v-if="curWebsite.type == 7">
				<p>上海国商慧人工智能技术有限公司</p>
				<p>联系电话：137 0189 6866&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;133 8110 9559</p>
				<p>地址:上海市南京西路1266号2期15楼 </p>
			</div>
			<p v-if="curWebsite.type == 1 || curWebsite.type == 9">
				<a href="https://beian.miit.gov.cn" target="_blank">粤ICP备2021132588号</a>
				<a target="_blank"
					href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44030402006498"><img
						src="../../assets/images/record.png" />粤公网安备 44030402006498号</a>
			</p>
			<p v-if="curWebsite.type == 2">
				<a href="https://beian.miit.gov.cn" target="_blank">粤ICP备2021132588号</a>
				<a target="_blank"
					href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44030402006500"><img
						src="../../assets/images/record.png" />粤公网安备 44030402006500号</a>
			</p>
			<p v-if="curWebsite.type == 3">
				<a href="https://beian.miit.gov.cn" target="_blank">粤ICP备2021132588号</a>
				<a target="_blank"
					href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44030402006499"><img
						src="../../assets/images/record.png" />粤公网安备 44030402006499号</a>
			</p>
			<p v-if="curWebsite.type == 4">
				<a href="https://beian.miit.gov.cn" target="_blank">粤ICP备2021132588号</a>
				<a target="_blank"
					href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44030402006496"><img
						src="../../assets/images/record.png" />粤公网安备 44030402006496号</a>
			</p>
			<p v-if="curWebsite.type == 5">
				<a href="https://beian.miit.gov.cn" target="_blank">粤ICP备2021132588号</a>
				<a target="_blank"
					href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44030402006497"><img
						src="../../assets/images/record.png" />粤公网安备 44030402006497号</a>
			</p>
			<p v-if="curWebsite.type == 6 || curWebsite.type == 10">
				<a href="https://beian.miit.gov.cn" target="_blank">粤ICP备17158032号</a>
				<a target="_blank"
					href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44030402006497"><img
						src="../../assets/images/record.png" /> 粤公网安备44030002002070号</a>
			</p>
			<p v-if="curWebsite.type == 7">
				<a href="https://beian.miit.gov.cn" target="_blank">沪ICP备2023029416号</a>
				<a class="dn" target="_blank"
					href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44030402006497"><img
						src="../../assets/images/record.png" />粤公网安备 44030402006497号</a>
			</p>

		</div>

		<rightNav :type="curWebsite.type == 7 ? 3 : 2" v-if="curWebsite.type != 8"></rightNav>
		<!-- <input type="hidden" name="_token" value="bwe4UyMX306KIOJCXhCsrHRYSECjBt9dC8teP63c"> -->
		<!-- 用户使用时间到期提示弹框 -->
		<div class="tipspopbox_bg" v-show="expiredBtn" v-if="!other_channel">
			<div class="tipspopbox">
				<span class="closebtn" @click="expiredBtn = false"></span>
				<div class="">
					<h5 class="title tac orangefont fz24 lh48">账号过期提醒</h5>
					<p class="mt-2 tac fz18 lh42">您的账号：<span class="darkred">{{ logindata.username }}</span>，已于<span
							class="darkred">{{ endDate }}</span>过期。<br>
						如需账号延期，请 <a class="curp" href="https://wpa1.qq.com/4sai7BwX?_type=wpa&qidian=true"
							target="_blank">在线咨询 ></a> ，或微信咨询：</p>
					<div class="right-slide-wechat mga por">
						<span class="wechatfont">扫一扫 加微信咨询我们</span>
						<div class="wechat_codebox fl">
							<img src="../../assets/images/zixuncode-lss.png">
							<p class="tac">中投顾问 - 刘姗姗</p>
						</div>
						<div class="wechat_codebox fr">
							<img src="../../assets/images/zixuncode-bl.png">
							<p class="tac">中投顾问 - 白灵</p>
						</div>
					</div>
				</div>
			</div>
			<!-- <div class="enprise_lockbox"> 
			<p class="redtips onetip" v-html="tipstext"></p>   
			<span class="closebtn" @click="expiredBtn=false"></span>
		</div> -->
		</div>
	</div>
</template>

<script>
import { is } from "core-js/core/object";
import { mapState, mapMutations, mapGetters } from "vuex";
export default {
	name: 'userlogin',
	computed: {
		...mapState({
			isMsgAlert: (state) => state.isMsgAlert,
			isSmsLogin: (state) => state.isSmsLogin,
			isDomainAllowedFlag: (state) => state.isDomainAllowedFlag,
			isDomainAllowedNum: (state) => state.isDomainAllowedNum
		}),
		...mapGetters(['isMsgAlert', 'isSmsLogin', 'isDomainAllowedFlag'])
	},
	props: {},
	data() {
		return {
			isPwdLogin: false,
			timerclock: null, //验证码计时器
			codeSecond: 0,//验证码倒计时
			isSendCode: false,
			expiredBtn: false,
			endDate: '',
			other_channel: false,
			testhref: "zhaoshangdanao.com.cn",
			curWebsite: this.$api.getWebsiteType(),
			demonstrate: this.$api.demonstrate(),
			autoOpenOperate: false,
			loginurl: this.$api.user.user.login(),
			isScroll: false,
			collectUrl: '',
			logindata: {
				username: "",
				password: '',
				phone: '',
				code: '',
				client: 1,
				token: null,
				refer: null,
				isPhoneNumber: false,
			},
			curList: {
				name: "",
				url: "",
				title: "",
				fontlist: []
			},
			errortext: '',
			isTzdn: false,
			nolocal: true,
			nowdate: new Date().getMonth() + 1 + '-' + new Date().getDate(),
			crmuserdata: {},
			list1: {
				xzbg: {
					code: "Z-XZBG",
					name: "下载报告",
					btn: false
				},
				jrxmgl: {
					code: "Z-JRXMGL",
					name: "加入项目管理",
					btn: false
				},
				jrmbqy: {
					code: "Z-JRMBQY",
					name: "加入目标企业",
					btn: false
				},
				jrqytzdt: {
					code: "Z-JRQYTZDT",
					name: "加入企业投资动态",
					btn: false
				},
				jyfznlpgbg: {
					code: "Z-JYFZNLPGBG",
					name: "经营发展能力评估报告",
					btn: false
				},
				cwfxbg: {
					code: "Z-CWFXBG",
					name: "财务分析报告",
					btn: false
				},
				mkczsm: {
					code: "Z-MKCZSM",
					name: "模块操作说明",
					btn: false
				},
			},
			zl_cydl_list: [{
				type: 6,
				name: '产业研究大脑',
				url: 'chanyeyanjiu.cn',
				title: "产业研究的数字化高效工具",
				fontlist: [
					'1000多份深度研究报告随意查看，实现“读报告自由” ',
					'240多条动态产业链图谱阅读，产业链上下游一览无余',
					'标杆企业、行业龙头企业投资布局、投资动态实时跟踪',
					'创新企业融资动态、风投机构投资动态，实时动态跟踪',
				]
			},
			{
				type: 5,
				name: '产业投资大脑',
				url: 'touzidanao.com',
				title: "企业战略投资部的数智化助手",
				fontlist: [
					'新兴产业、热门赛道所有投资标的智能推荐',
					'所有专业投资机构投资动态，全面动态监测',
					'标杆企业、行业龙头投资动态实时跟踪',
					'动态产业图谱，沿产业链梳理各环节企业'
				]
			},
			{
				type: 1,
				name: '产业招商大脑',
				url: 'zhaoshangdanao.com',
				title: "大数据精准招商专业平台",
				fontlist: [
					'产业链招商，找行业龙头企业',
					'到北上深驻点招商，找当地龙头企业',
					'判断一家企业的投资意向',
					'通过关系计算器，获得企业的联系方式'
				]
			},
			],
			typelist: [{
				type: 1,
				name: '产业招商大脑',
				url: 'zhaoshangdanao.com',
				title: "大数据精准招商专业平台",
				fontlist: [
					'产业链招商，找行业龙头企业',
					'到北上深驻点招商，找当地龙头企业',
					'判断一家企业的投资意向',
					'通过关系计算器，获得企业的联系方式'
				]
			},
			{
				type: 9,
				name: '产业招商大脑',
				url: 'sima.chanyedanao.cn',
				title: "大数据精准招商专业平台",
				fontlist: [
					'产业链招商，找行业龙头企业',
					'到北上深驻点招商，找当地龙头企业',
					'判断一家企业的投资意向',
					'通过关系计算器，获得企业的联系方式'
				]
			},
			{
				type: 8,
				name: '产业招商大脑',
				url: 'zs.chanyedanao.cn',
				title: "大数据精准招商专业平台",
				fontlist: [
					'产业链招商，找行业龙头企业',
					'到北上深驻点招商，找当地龙头企业',
					'判断一家企业的投资意向',
					'通过关系计算器，获得企业的联系方式'
				]
			},
			{
				type: 2,
				name: '产业大脑-产业治理大脑',
				url: 'chanyedanao.cn',
				title: "政府产业治理部门的高效工具",
				fontlist: [
					'通过本地产业图谱，自动诊断本地产业链的完整度',
					'240条全国产业图谱，随便查找产业各环节重点企业',
					'全国所有重点企业投资动态，实时跟踪监测',
					'处于投资窗口期、发展机会大的产业，智能推荐'
				]
			},
			{
				type: 3,
				name: '园区招商大脑',
				url: 'yuanqudanao.com',
				title: "",
				fontlist: []
			},
			{
				type: 4,
				name: '产业大脑-产业信贷大脑',
				url: 'xindaidanao.com',
				title: "企业信贷需求挖掘高效工具",
				fontlist: [
					'沿着产业链图谱，快速锁定行业重点企业',
					'产业链金融，围绕龙头企业上下游找融资企业',
					'投贷联动，挖掘有资质、有融资需求的科技型企业',
					'企业投资（融资）窗口期，挖掘信贷需求大的企业',
				]
			},
			{
				type: 5,
				name: '产业投资大脑',
				url: 'touzidanao.com',
				title: "企业战略投资部的数智化助手",
				fontlist: [
					'新兴产业、热门赛道所有投资标的智能推荐',
					'所有专业投资机构投资动态，全面动态监测',
					'标杆企业、行业龙头投资动态实时跟踪',
					'动态产业图谱，沿产业链梳理各环节企业'
				]
			},
			{
				type: 6,
				name: '产业研究大脑',
				url: 'chanyeyanjiu.cn',
				title: "产业研究的数字化高效工具",
				fontlist: [
					'1000多份深度研究报告随意查看，实现“读报告自由” ',
					'240多条动态产业链图谱阅读，产业链上下游一览无余',
					'标杆企业、行业龙头企业投资布局、投资动态实时跟踪',
					'创新企业融资动态、风投机构投资动态，实时动态跟踪',
				]
			},
			{
				type: 10,
				name: '产业研究大脑',
				url: 'cs.chanyedanao.cn',
				title: "产业研究的数字化高效工具",
				fontlist: [
					'1000多份深度研究报告随意查看，实现“读报告自由” ',
					'240多条动态产业链图谱阅读，产业链上下游一览无余',
					'标杆企业、行业龙头企业投资布局、投资动态实时跟踪',
					'创新企业融资动态、风投机构投资动态，实时动态跟踪',
				]
			},
			{
				type: 7,
				name: '上海产业集群大数据平台',
				url: 'zhaoshangdanao.com.cn',
				title: "",
				fontlist: []
			},
			],
			isShowZldnM: 0,
		}
	},
	created() {
		const temLoginType = JSON.parse(localStorage.getItem('loginType'));
		this.isPwdLogin = temLoginType ? temLoginType.loginTypePwd : false;
		console.log('this.isPwdLogin', this.isPwdLogin);
		var ddd = this.typelist.filter(list => {
			return list.type == this.curWebsite.type;
		});
		this.curList = ddd[0];
		document.title = this.curList.name;
		if (this.curList.name == '产业研究大脑') {
			document.title = "中投大数据" + this.curList.name;
		}
		if (this.curWebsite.type == 2) {
			document.title = "中投顾问产业大脑，产业研究咨询数智化高效工具";

		}
		this.logindata.refer = this.$route.query.refer;
		this.logindata.token = this.$route.query.token;
		// console.log(this.loginurl)
	},
	mounted() {
		this.bus.$emit('loading', false);
		// console.log('来源-----', document.referrer);
		var that = this;
		document.getElementById('loginpage').addEventListener('scroll', function () {
			that.isScroll = this.scrollTop > 168;
		})
		this.other_channel = this.curWebsite.type == 7 || this.curWebsite == 8;
		//2024-20.23 体验版跳转过来需要定位到服务介绍，增加了锚点定位
		const hash = window.location.hash;

		// 定义需要检查的锚点列表
		const anchorList = ['login-service', 'login-introduction'];

		// 查找匹配的锚点
		const matchedAnchor = anchorList.find(anchor => hash.includes(`#${anchor}`));

		if (matchedAnchor) {
			const element = document.getElementById(matchedAnchor);
			if (element) {
				element.scrollIntoView({ behavior: 'smooth' }); // 平滑滚动到目标元素
			}
		} else {
			// 如果没有匹配的锚点，检查是否需要执行域名验证逻辑
			if (this.isDomainAllowedFlag) {
				this.isDomainAllowed();
			}
		}
		if (this.logindata.token && this.logindata.refer) { //陕投默认登录入口
			this.logindata.token = this.decodeURI(this.logindata.token);
			this.logindata.refer = this.decodeURI(this.logindata.refer);
			console.log(this.logindata);
			this.passwordLogin();
		}
	},

	methods: {
		...mapMutations({
			set_msgAlert: "SET_MSGAlERT",
			set_isSmsLogin: "SET_ISSMSLOGIN",
			set_isDomainAllowedFlag: "SET_ISDOMAINALLOWEDFLAG",
			SET_ISDOMAINALLOWEDNUM: "SET_ISDOMAINALLOWEDNUM",
		}),
		//在线咨询打开小窗口
		openSmWindow(url) {
			try {
				window.open(url, "_blank", "height=600,width=800,top=200,left=200,status=yes,toolbar=no,menubar=no,resizable=yes,scrollbars=no,location=no,titlebar=no");
				_hmt.push(['_trackEvent', '报告', '咨询', '在线客服'])
			} catch (e) { }
			return false;
		},
		// 点击服务方式 、产品介绍跳转
		hanlderService(sectionId) {
			console.log(sectionId);

			const section = this.$refs[sectionId];
			if (section) {
				section.scrollIntoView({ behavior: 'smooth' }); // 平滑滚动
			}
		},
		//陕投项目会从他们那边跳转过来到我们企业详情，要默认给他登陆方便查看
		// base64解密
		decodeURI(text) {
			console.log(text);
			text = text.replace(/%3D/ig, '=').replace(/-/g, '+').replace(/_/g, '/');
			return window.atob(text);
		},
		// 判断域名
		isDomainAllowed() { //从我们自己宣传也进来的绕过登录页，市场部开的账号到登录页
			const hostname = document.referrer;
			console.log(hostname);
			const allowedDomains = 'ocn.com.cn';
			let isAllowed = hostname.indexOf(allowedDomains) > -1;

			// 检查本地存储中的标志
			const isFirstVisit = localStorage.getItem('isFirstVisit') !== 'false';

			if (isAllowed && isFirstVisit) {
				// 首次访问，跳转到 totalEnterprises
				localStorage.setItem('isFirstVisit', 'false'); // 更新标志，防止后续跳转
				this.set_isDomainAllowedFlag(false);
				this.$router.push('/totalEnterprises');
			}
	},

	// 校验手机号是否正确
	checkInput() {
		return new Promise((resolve, reject) => {
			console.log(this.logindata.phone);
			this.logindata.isPhoneNumber = false;
			this.set_isSmsLogin(false);
			// this.isSmsLogin = false;
			let phone_number_reg = /^((\+|00)86)?1[3-9]\d{9}$/;
			if (this.logindata.phone != '') {
				if (phone_number_reg.test(this.logindata.phone)) {
					this.logindata.isPhoneNumber = true;
					this.checkSmsLogin().then(res => {
						resolve(res);
					})
				} else {
					this.errortext = '请输入正确的手机号';
					resolve(false);
				}
			} else {
				this.errortext = '手机号不能为空';
				resolve(false);

			}
		})

	},
	//调用后台接口检测手机号是否设置为短信登陆
	checkSmsLogin() {
		return new Promise((resolve, reject) => {
			let _this = this;
			let ajaxUrl = this.$api.common.sms.isSmsLogin() + "?mobile=" + this.logindata.phone;
			this.$axios.get(ajaxUrl).then(function (res) {
				console.log('检测是否设置短信登陆', res);
				if (res.data.success) {
					_this.set_isSmsLogin(true);
					_this.errortext = '';
					resolve(true);
					// _this.isSmsLogin = true;
				} else {
					_this.set_isSmsLogin(false);
					_this.errortext = '您尚未开通短信登录服务，请联系客服';
					// _this.isSmsLogin = false;
					resolve(false);
				}
			}).catch(function (error) {
				// 处理错误情况
				console.log(error);
			})
		})

	},
	//发送验证码
	sendCode() {
		this.checkInput().then(res => {
			if (!res) {
				return;
			} else {
				let _this = this;
				let ajaxUrl = this.$api.common.sms.send() + "?mobile=" + this.logindata.phone + '&type=2';
				this.$axios.get(ajaxUrl).then(function (res) {
					// console.log('发送验证码',res); 
					if (res.data.success) {
						_this.$message.success(res.data.msg);
						if (res.data.code == 0) {
							_this.codeSecond = 60;
							_this.timerclock = setInterval(function () { //设置1分钟倒计时定时器
								_this.codeSecond--;
								if (_this.codeSecond == 0) {
									clearInterval(_this.timerclock) //清空定时器
								}
								// console.log(_this.codeSecond)
							}, 1000)
						}
					} else {
						let errMsg = res.data.msg;
						if (res.data.code == 1022) {
							errMsg = '短信日下发条数超过设定的上限';
						} else if (res.data.code == 1023) {
							errMsg = '手机号30秒内下发短信条数超过设定的上限';
						} else if (res.data.code == 1024) {
							errMsg = '手机号1小时内下发短信条数超过设定的上限';
						} else if (res.data.code == 1025) {
							errMsg = '手机号日下发短信条数超过设定的上限';
						}
						_this.$message.error(errMsg);
					}

				}).catch(function (error) {
					// 处理错误情况
					console.log(error);
				})
			}
		})


	},
	addToBookMark() {
		var url = window.location.href;
		var title = this.curWebsite.name;
		var ua = navigator.userAgent.toLowerCase();
		if (ua.indexOf("msie 8") > -1) {
			external.AddToFavoritesBar(url, title, "河北超高压"); //IE8
		} else {
			try {
				window.external.addFavorite(url, title);
			} catch (e) {
				try {
					window.sidebar.addPanel(title, url, "河北超高压"); //firefox
				} catch (e) {
					alert("加入收藏失败，请使用Ctrl+D进行添加");
				}
			}
		}
		return false;
	},
	inputInDown(e) {
		if (e.keyCode == 13) {
			this.passwordLogin()
		};
	},
	passwordLogin() {
		if (!this.isPwdLogin) {
			this.checkInput().then(res => {
				if (!res) {
					return;
				}
			})
		}
		// 如果是短信登陆则清空密码，密码登陆清空验证码，防止有自动填充情况出现
		if (this.logindata.token && this.logindata.refer) {
			this.logindata.password = '';
			this.logindata.username = '';
		} else if (this.isSmsLogin || !this.isPwdLogin) {
			// console.log('短信登陆-------------');
			this.logindata.password = '';
			this.logindata.username = this.logindata.phone;
			if (this.logindata.phone == '' || this.logindata.code == '') {
				this.errortext = '未填写用户名/验证码';
				return;
			};
		} else {
			this.logindata.code = '';
			if (this.logindata.username == '' || this.logindata.password == '') {
				this.errortext = '未填写用户名/密码';
				return;
			};
		}
		// console.log('登陆',this.logindata);

		var that = this;
		var loginurl = this.$api.user.user.login();
		this.bus.$emit('loading', true);
		// +'?username='+this.logindata.username+'&password='+this.logindata.password+'&client=1' 
		$.ajax({
			type: "post",
			url: loginurl,
			data: this.logindata,
			success: function (res) {
				var resdata = res;
				console.log('登陆返回', resdata);
				// resdata.success=false;
				// resdata.msg='用户过期123';
				// resdata.data='2024-2-21';
				// resdata.code = 100102;
				if (resdata.success) {
					var logindata = resdata.data;
					if (logindata.domain.indexOf('yj.chanyedanao') > -1) {
						logindata.domain = logindata.domain +
							',tg.chanyedanao.cn,//chanyedanao,www.chanyedanao.cn';
					}
					that.loginsuccess(logindata);
					localStorage.setItem('token', logindata.token);
					sessionStorage.setItem('token', logindata.token);
				} else {
					that.bus.$emit('loading', false);
					that.errortext = resdata.msg;
					if (resdata.code == 100102 && !that.other_channel) {
						that.expiredBtn = true;
						that.endDate = resdata.data;
					}
				}
			}
		})
	},
	loginsuccess(datasm) {
		console.log('loginsucces 设置消息提示');
		//记录当前登录方式，下次默认当前登录方式
		localStorage.setItem('loginType', JSON.stringify({ loginTypePwd: this.isPwdLogin }));
		//20240422设置登陆成功1分钟后促销消息提示
		setTimeout(() => {
			this.set_msgAlert(true);
		}, 60000);
		datasm.currentCity = this.getSetCity(datasm); //将用户所在地区提取出来 
		datasm.autoOpenOperate = false;
		datasm.datetime = this.nowdate;
		var oplist = datasm.menu.filter(list => {
			return list.code == 'Z';
		});
		// console.log('没有修改的原始数据',datasm,oplist);

		datasm.operatList = this.operatList(oplist[0].children);
		this.$axios.get(this.$api.cyl.home.notice(), {
			headers: {
				AuthToken: datasm.token
			}
		}).then(function (res) { }).catch(function (error) { });
		this.crmlogin(datasm);
	},
	//用户工作台权限
	crmlogin(datasm) {
		var that = this;
		console.log('crmlogin5')
		that.routerLoginUrl(datasm);
		// that.bus.$emit('loading', false);
		$.ajax({
			type: "get",
			url: this.$api.crm.user.login(),
			headers: {
				AuthToken: datasm.token
			},
			success: function (res) {
				if (res.success) {
					that.crmuserdata = res.data;
					datasm.crmInfor = res.data;
					that.routerLoginUrl(datasm);
					that.bus.$emit('loading', false);
				}
			}
		})
		/***/


		// this.bus.$emit('loading', true);  
		// this.$axios.get(this.$api.crm.user.login(),{headers:{AuthToken:datasm.token}}).then(function(res){ 
		// 	console.log('2',res,datasm)
		// 	if(res.data.success){    
		// 		that.crmuserdata = res.data.data;
		// 		datasm.crmInfor=res.data.data; 
		// 		that.routerLoginUrl(datasm);  
		// 		localStorage.setItem('userData', datasm);
		// 		sessionStorage.setItem('userData', datasm);  
		// 		that.bus.$emit('loading', false); 
		// 	}
		// 	else{ 

		// 	} 
		// }).catch(function (error) {
		// 	// 请求失败处理 console.log(error);
		// });  
	},
	//版本判断是否能进入
	routerLoginUrl(datasm) {
		var datasm1 = '';
		// datasm.groupType=0;  datasm.loginNum=1;//试用账号测试专用
		datasm.autoOperate = false;
		let type1 = datasm.groupType == 1 ? 1 : 0;
		datasm.zsdn_version = (this.curWebsite.type == 1 || this.curWebsite.type == 7) ? type1 + 1 : 2;//简易版和专业版的初始设置 招商大脑试用账户默认进入简易版


		datasm.zsdn_version_num = 1;//简易版和专业版切换次数 
		datasm.isChannel = false;//当前页面登录的用户为非渠道用户
		//拦截token设置特殊token
		// datasm.token ='4aef66eae5b3026530eb2625048bf8bc';
		// datasm.province = 36;
		if (typeof datasm === 'object') {
			datasm1 = JSON.stringify(datasm);
		}
		// console.log('routerLoginUrl',datasm1)
		var isMatch = false;
		var showcom = datasm.domain.split(',');
		var hrefl = window.location.href.toLowerCase();
		for (var i = 0; i < showcom.length; i++) {
			if (hrefl.indexOf(showcom[i]) > -1) {
				isMatch = true;
			}
		}
		this.nolocal = hrefl.indexOf(".cn") > 0 || hrefl.indexOf(".com") > 0;
		// console.log('logindata',logindata);
		// console.log(hrefl,'登录时网址') 
		if (this.nolocal && !isMatch) {
			// that.errortext="账号与版本不对应，请进入正确版本";
			this.$message({
				message: '账号与版本不对应，请进入正确版本,3s后跳转',
				type: 'error'
			})
			setTimeout(function () {
				window.location.href = "http://" + showcom[0];
			}, 4000)
		} else {

			localStorage.setItem('userData', datasm1);
			sessionStorage.setItem('userData', datasm1);
			var curWebsite = this.$api.getWebsiteType();
			console.log('curWebsiteLogin', curWebsite);
			var indexPath = "";
			if (datasm.isPopup && !(this.logindata.token && this.logindata.refer)) { //后台设置了是否要默认进入首页
				indexPath = "/homePage";
			} else if (this.logindata.token && this.logindata.refer) { //陕投跳转
				indexPath = this.logindata.refer

			} else if (curWebsite.type == 3 || curWebsite.type == 4) {
				//园区/信贷大脑跳转全部楼宇页面
				indexPath = "/allBuildings";
			} else if (curWebsite.type == 5) {
				//投资大脑跳创新企业融资页面
				indexPath = "/investment-clues3";
			} else if (curWebsite.type == 6) {
				//研究大脑跳转省市区域竞争 
				// indexPath="/regional-competitiveness?type=2"; 
				// 研究大脑跳转产业机会在哪里
				indexPath = "/report?type=w0";
			} else if (curWebsite.type == 1 || curWebsite.type == 7) {
				//招商大脑和上海数据平台有简易版
				if (datasm.groupType == 1) {
					indexPath = "/totalEnterprises";
				} else {
					indexPath = "/invest-project-trend?type=3";//试用账户自动设置成简易版 企业本市投资项目
				}
			} else {
				//其余跳上市企业
				indexPath = "/enterpriseList?type=9&Pt=1";
			}
			console.log('跳转', indexPath)
			this.$router.push({
				path: indexPath,
			});
		}
	},
	//下载/项目管理等权限存储
	operatList(data) {
		for (var i = 0; i < data.length; i++) {
			let code1 = data[i].code;
			// console.log(code1);
			if (code1 == "Z-XZBG") { //11.30修改所有版本内资企业都有下载报告按钮
				this.list1.xzbg.btn = true;
			} else if (code1 == "Z-JRXMGL") {
				this.list1.jrxmgl.btn = true;
			} else if (code1 == "Z-JRMBQY") {
				this.list1.jrmbqy.btn = true;
			} else if (code1 == "Z-JRQYTZDT") {
				this.list1.jrqytzdt.btn = true;
			} else if (code1 == "Z-JYFZNLPGBG") {
				this.list1.jyfznlpgbg.btn = true;
			} else if (code1 == "Z-CWFXBG") {
				this.list1.cwfxbg.btn = true;
			} else if (code1 == "Z-MKCZSM" && this.curWebsite.type == 1) {
				this.list1.mkczsm.btn = true; //只有招商大脑才要展示模块和服务手册
			}
		};
		return this.list1;
	},

},

	}
</script>

<style scoped lang="scss">
.swiper-item {
	position: relative;
	height: 100%;
	width: 100%;
}

.swiper-item1 {
	background: url('../../assets/zs_login_banner1.jpg');
	background-size: 100% 100%;

}

.swiper-item2 {
	background: url('../../assets/zs_login_banner2.jpg');
	background-size: 100% 100%;

}

.swiper-item3 {
	background: url('../../assets/zs_login_banner3.jpg');
	background-size: 100% 100%;

}

.swiper-item4 {
	background: url('../../assets/zs_login_banner4.jpg');
	background-size: 100% 100%;

}

.syzs-login {
	height: 97vh;
	width: 100vw;
	/* border:1px solid red; */
}

.syzs-login1 {
	min-height: 105vh;
	width: 100vw;
	background: url('../../assets/zs_login_banner.jpg');
	background-size: 100% 100%;
	color: #fff;
}

.el-carousel--horizontal {
	width: 100vw;
	/* border:1px solid green; */
}

.website-company {
	text-align: center;
	display: block;
	/* color: #333; */
	font-size: 20px;
}

.el-carousel__item h3 {
	color: #475669;
	font-size: 18px;
	opacity: 0.75;
	line-height: 300px;
	margin: 0;
}

.el-carousel__item:nth-child(2n) {
	background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n+1) {
	background-color: #d3dce6;
}

.login_type {
	margin-top: 16px;
	color: #999;
	font-weight: bold;
	cursor: pointer;

	&.active {
		color: #528ad4;
		border-bottom: 2px solid #528ad4;
	}

	&.active-fff {
		color: #ffffff;
		border-bottom: 2px solid #ffffff;
	}
}
</style>